import * as angular from 'angular';

export class BulkModeService {

    constructor() {
    }

    attachBulkModeFunctions(ctrl, itemListCtrlProp, idKey) {
        ctrl.bulkModeEnabled = false;
        ctrl.batchItems = [];

        ctrl.enableBulkMode = function() {
            ctrl.bulkModeEnabled = true;
        }

        ctrl.disableBulkMode = function() {
            ctrl.bulkModeEnabled = false;
            ctrl.batchItems = [];
        };

        ctrl.itemInBatch = function(itemId) {
            return ctrl.batchItems.includes(itemId);
        };

        ctrl.allItemsInBatch = function() {
            return ctrl[itemListCtrlProp].results.every(function(item) {
                return ctrl.itemInBatch(item[idKey]);
            });
        };

        ctrl.batchIsEmpty = function() {
            return ctrl.batchItems.length === 0;
        };

        ctrl.addToBatch = function(itemId) {
            ctrl.batchItems = ctrl.batchItems.concat([itemId]);
        };

        ctrl.addAllToBatch = function() {
            ctrl.batchItems = ctrl[itemListCtrlProp].results.map(function(item) {
                return item[idKey];
            });
        };

        ctrl.removeFromBatch = function(itemId) {
            ctrl.batchItems = ctrl.batchItems.filter(function(id) {
                return id !== itemId;
            });
        };

        ctrl.resetBatch = function() {
            ctrl.batchItems = [];
        };

        ctrl.bulkAllItemsClickHandler = function() {
            if (ctrl.allItemsInBatch()) {
                ctrl.resetBatch();
            } else {
                ctrl.addAllToBatch();
            }
        };

        ctrl.bulkItemClickHandler = function(itemId) {
            if (ctrl.itemInBatch(itemId)) {
                ctrl.removeFromBatch(itemId);
            } else {
                ctrl.addToBatch(itemId);
            }
        };
    }
}

angular
    .module('app')
    .service('BulkModeService', BulkModeService);



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/services/bulk-mode.service.ts